/**
 * Compares two values for equality, with special handling for arrays.
 *
 * @param value1 - First value to compare
 * @param value2 - Second value to compare
 * @returns true if values are equal, false otherwise
 */
export const areValuesEqual = <T>(value1: T, value2: T): boolean => {
  if (value1 === value2) return true
  if (value1 == null || value2 == null) return false
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return JSON.stringify(value1) === JSON.stringify(value2)
  }
  return false
}
